// extracted by mini-css-extract-plugin
export default {"error":"qknFtBBfB0Q9PVMjWKmY","spinner":"s9a63lSAoWHCautKslRM"};